export type SurfaceFunction = (x: number, y: number) => number;

export function planeEquationGenerator(baseZValue = 0): SurfaceFunction {
  return () => baseZValue;
}

export function stepPlaneEquationGenerator(
  baseZValue = 0,
  highZValue = 1,
  stepAt = 0,
): SurfaceFunction {
  return (x: number) => (x >= stepAt ? highZValue : baseZValue);
}

export function slopeXPlaneEquationGenerator(
  baseZValue = 0,
  slope = 6,
): SurfaceFunction {
  return (x: number) => x / slope + baseZValue;
}
